import { render, staticRenderFns } from "./ProjectRequestTab.vue?vue&type=template&id=5d3dc0ad&"
import script from "./ProjectRequestTab.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRequestTab.vue?vue&type=style&index=0&id=5d3dc0ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports